module.exports = __webpack_public_path__ + "static/media/pic1.1b0a4ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic1.png
// module id = 230
// module chunks = 0